import { render, staticRenderFns } from "./mwcarbon.vue?vue&type=template&id=87ccba12&scoped=true"
import script from "./mwcarbon.vue?vue&type=script&lang=js"
export * from "./mwcarbon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ccba12",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CarbonCreditsMarketWatch: require('/vercel/path0/components/datablocks/CarbonCreditsMarketWatch.vue').default})
